import clsx from 'clsx';

import { ReactComponent as ChevronRightPageSelectorIcon } from '@/assets/icons/chevron_page_selector_right.svg';
import { ReactComponent as ChevronLeftPageSelectorIcon } from '@/assets/icons/chevron_page_selector_left.svg';

import styles from './component.module.scss';

const Pagination = ({
  currentPage,
  totalPages,
  pageSize,
  totalItems,
  onPageChange,
  className
}: {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalItems: number;
  onPageChange: (pageNumber: number) => void;
  className?: string;
}) => {
  const pages: React.ReactNode[] = [];

  const ellipsis = <div className={clsx(styles.selectorBox)}>...</div>;

  const getPageIndexSelectorBox = (pageIndex: number) => (
    <div
      className={clsx(
        styles.selectorBox,
        styles.pageNumber,
        currentPage !== pageIndex && styles.clickable,
        currentPage === pageIndex && styles.selected
      )}
      onClick={() => currentPage !== pageIndex && onPageChange(pageIndex)}
    >
      {pageIndex + 1}
    </div>
  );

  // Less than 6 pages
  if (totalPages <= 6) {
    for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
      pages.push(getPageIndexSelectorBox(pageIndex));
    }
  }

  // First 3 pages and Last 3 Pages
  else if (
    (totalPages > 6 && currentPage <= 2) ||
    (totalPages > 6 && currentPage >= totalPages - 4)
  ) {
    pages.push(getPageIndexSelectorBox(0));
    pages.push(getPageIndexSelectorBox(1));
    pages.push(getPageIndexSelectorBox(2));
    pages.push(ellipsis);
    pages.push(getPageIndexSelectorBox(totalPages - 3));
    pages.push(getPageIndexSelectorBox(totalPages - 2));
    pages.push(getPageIndexSelectorBox(totalPages - 1));
  } else {
    pages.push(getPageIndexSelectorBox(currentPage - 1));
    pages.push(getPageIndexSelectorBox(currentPage));
    pages.push(getPageIndexSelectorBox(currentPage + 1));
    pages.push(ellipsis);
    pages.push(getPageIndexSelectorBox(totalPages - 3));
    pages.push(getPageIndexSelectorBox(totalPages - 2));
    pages.push(getPageIndexSelectorBox(totalPages - 1));
  }

  return (
    <div className={clsx(styles.main, className)}>
      <div className={styles.resultsInfo}>
        Showing <span>{currentPage * pageSize + 1}</span> to{' '}
        <span>{Math.min((currentPage + 1) * pageSize, totalItems)}</span> of{' '}
        <span>{totalItems}</span> results
      </div>
      <div className={styles.pageSelector}>
        <div
          className={clsx(
            styles.selectorBox,
            currentPage !== 0 && styles.clickable,
            currentPage === 0 && styles.disabled
          )}
          onClick={() => currentPage !== 0 && onPageChange(currentPage - 1)}
        >
          <ChevronLeftPageSelectorIcon />
        </div>
        {pages}
        <div
          className={clsx(
            styles.selectorBox,
            currentPage !== totalPages - 1 && styles.clickable,
            currentPage === totalPages - 1 && styles.disabled
          )}
          onClick={() =>
            currentPage !== totalPages - 1 && onPageChange(currentPage + 1)
          }
        >
          <ChevronRightPageSelectorIcon />
        </div>
      </div>
    </div>
  );
};

export { Pagination };
